import addStepTextInFooter from './js/add-step-text-in-footer';
import animationBetweenSections from './js/animation-between-sections';
// import centerSectionOnInputFocus from './js/center-section-on-input-focus';
import toggleFormDescription from './js/toggle-form-description';
import { stickyHeader } from './js/sticky-header';
import openTextAreas from './js/open-text-areas';
import showOtherOptionInput from './js/show-other-option-input';
import { onAddDoctor } from './js/on-add-doctor';
import { saveTempForm } from './js/save-temp-form';
import { cancelFormModal } from './js/cancel-form';
import { cleanFormQueryParams } from './js/clear-query-params';
import { addSaveFormInFooter } from './js/add-save-form-in-footer';
import { addAutocompleteFields } from './js/add-autocomplete-fields';
import { addAutocompleteFieldForDoctors } from './js/add-autocomplete-field-for-doctors';
import { deleteEntryListener, deleteEntryFromForm } from './js/delete-entry';
import { goBackOnRegisterModal } from './js/go-back-on-register-modal';
import enableEditionMode from './js/edition-mode.js';
import insuranceCompanyAutoComplete from './js/insurance-company-autocomplete';
import insuredAutoComplete from './js/insured-autocomplete';
import adjusterAutoComplete from './js/adjuster-autocomplete';

const selectors = {
	privacyPolicyModal: '#ime-privacy-policy',
};

/**
 * All IME Form functionnality.
 */
function imeForm() {
	if ( document.querySelector( '.ime' ) ) {
		addStepTextInFooter();
		animationBetweenSections();
		// TODO improve section focus function.
		// centerSectionOnInputFocus();
		toggleFormDescription();
		stickyHeader();
		showOtherOptionInput();
		onAddDoctor();
		saveTempForm();
		cancelFormModal();
		cleanFormQueryParams();
		addSaveFormInFooter();
		deleteEntryListener();
		deleteEntryFromForm();
		enableEditionMode();

		addIMEFormInputAutocompletes();
	}

	if ( document.querySelector( '.gform_wrapper' ) ) {
		openTextAreas();
	}
	if ( document.querySelector( '.o__ime-form-entry' ) ) {
		deleteEntryListener();
	}
	goBackOnRegisterModal();

	setupPolicyModal();
}

/**
 * Set up IME form privacy policy modal.
 * @returns
 */
function setupPolicyModal() {
	window.mce = 'mce' in window ? window.mce : {};
	const cookieDuration = window.mce.privacy_policy_cookie_duration;
	const policyModalEl = document.querySelector(selectors.privacyPolicyModal);
    if (!cookieDuration || !policyModalEl) {
        return;
    }

	const acceptPolicyBtn = policyModalEl.querySelector('.js-accept-privacy-policy');
	const closePolicyBtn = policyModalEl.querySelector('.js-close-modal');
    if ( closePolicyBtn && acceptPolicyBtn) {
        acceptPolicyBtn.addEventListener('click', event => {
            event.preventDefault();
			const chkEl = policyModalEl.querySelector('#id-ime-privacy-accept');
			if (chkEl && chkEl.checked) {
				setCookie('privacy-policy-accepted', true, cookieDuration);
				closePolicyBtn.click();
			}
        })

		setTimeout(
			() => {
				if ('true' !== getCookie('privacy-policy-accepted')) {
					showModal(policyModalEl);
				}
			},
			2500
		)
    }
}

/**
 * Show a modal.
 *
 * @param {Element} modalEl The modal element to show.
 */
function showModal(modalEl) {
	modalEl.classList.remove('visuallyhidden');
}

/**
 * Set up IME Form autocomplete fields.
 */
function addIMEFormInputAutocompletes() {
	adjusterAutoComplete();
	addAutocompleteFields( 'attorneys' );
	addAutocompleteFieldForDoctors();
	insuranceCompanyAutoComplete();
	insuredAutoComplete();
}

/**
 * Creat a IME Form cookie.
 *
 * @param {String} cName Cookie name.
 * @param {String} value Cookie value
 * @param {Number} exdays Cookie expiration in days.
 */
function setCookie(cName, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var cValue = `${value}${((exdays == null) ? '' : '; expires=' + exdate.toUTCString())}`;
    document.cookie = `ime-${cName}=${cValue}`;
}

/**
 * Get a cookie value by name.
 *
 * @param {String} cName Cookie name.
 * @returns
 */
function getCookie(cName) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let name = cookies[i].substr(0, cookies[i].indexOf('='));
        const value = cookies[i].substr(cookies[i].indexOf('=') + 1);
        name = name.replace(/^\s+|\s+$/g, '');
        if (name === `ime-${cName}`) {
            return value;
        }
    }

	return '';
}

export default imeForm;
